var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { SpinnerIcon, translate } from '@lucidlink/uicore';
import { FilespaceListItemTestIdFactory } from '../../interactions';
export const StatusInProgressIcon = ({ filespaceId, ref }) => {
    return (_jsx(SpinnerIcon, { "aria-label": translate('In progress'), color: "accent", "data-testid": FilespaceListItemTestIdFactory.getFilespaceListItemStatusIconTestId('inprogress', filespaceId), ref: ref, size: "xsmall" }));
};
_react_refresh_temp_1 = StatusInProgressIcon;
$RefreshReg$(_react_refresh_temp_1, "StatusInProgressIcon");
